'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosRose = function IoIosRose(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.5 10c-6 7.5-1.2 11.8-1.2 17.5s-4.4 10-11.3 10-11.2-4.3-11.2-10 2.7-8.5 7.2-11.1c2-1.1 2.6-1.5 4.1-2.2 2.3-1.1 5.1-2.2 8.2-3.1 1.3-0.4 2.7-0.8 4.2-1.1z m-25-2.5s5.2 1.2 9 3.4c1.2 0.6 2.2 1.4 2.9 2.2-1 0.5-1.9 1-2.8 1.5-0.6 0.3-1.1 0.6-1.6 0.9-2 1.3-3.4 2.5-4.5 3.3 0.4-3.2 0.2-7.6-3-11.3z m20-2.5s2 2.5 2.5 4.3c-2.6 0.6-6.6 2-9.5 3.3l-0.2-0.3c-0.7-0.8-1.7-1.7-3-2.5 4-4.6 10.2-4.8 10.2-4.8z m-13.7-2.5s2.7 1.3 5 4.4c-1 0.7-1.8 1.5-2.6 2.4-2.1-1-3.2-1.6-4.8-2.1 0.4-1.2 1.2-3 2.4-4.7z' })
        )
    );
};

exports.default = IoIosRose;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-rose.js
// module id = 2510
// module chunks = 0